/**
 * title 菜单标题
 * name 路由名称
 * path 路由地址，不填写则不初始化路由
 * component 路由组件地址，不填写则不初始化路由
 * redirect 路由重定向
 * hideInMenu 是否隐藏菜单 默认展示 true
 * showName 配合hideInMenu使用 隐藏后菜单栏展示对应的active
 * child 子路由
 * hasGroup 是否是分组
 * pname 旧saas跳转链接额外参数
 */
let Main = () => import('@/components/main')
export const menu = [
  {
    title: '首页',
    name: 'home',
    path: '/',
    component: Main,
    secondMenuTitle: '首页',
    child: [
      {
        title: '首页',
        name: 'index',
        path: '/',
        component: () => import('@/view/home/index.vue')
      },
      {
        title: '选品设置',
        name: 'index',
        hasGroup: true,
        path: '/',
        component: () => import('@/view/home/index.vue'),
        child: [
          {
            title: '供应链选品库',
            name: 'supplyChainStore',
            path: 'supplyChainStore',
            keepAlive: true,
            component: () => import('@/view/autarky/supplyChainStore.vue')
          },
          {
            title: '选品设置',
            name: 'addshopTostore',
            path: 'addshopTostore',
            hideInMenu: true,
            component: () => import('@/view/autarky/addshopTostore.vue')
          },
          {
            title: '本地商品库',
            name: 'localstore',
            path: 'localstore',
            keepAlive: true,
            component: () => import('@/view/autarky/localstore.vue')
          },
          // {
          //   title: '免费店商品',
          //   name: 'freestore',
          //   path: 'freestore',
          //   keepAlive: true,
          //   component: () => import('@/view/autarky/freestore.vue')
          // }
        ]
      },
      {
        title: '商城设置',
        hasGroup: true,
        child: [
          {
            title: '商城分类设置',
            name: 'shopcategorylist',
            path: 'shopcategorylist',
            component: () => import('@/view/autarky/shopcategorylist.vue')
          },
          {
            title: '活动分类配置',
            name: 'activityclassfy',
            path: 'activityclassfy',
            component: () => import('@/view/autarky/activityclassfy.vue')
          },
          {
            title: '活动列表',
            name: 'activitylist',
            path: 'activitylist',
            component: () => import('@/view/autarky/activitylist.vue')
          },
          {
            title: '红包兑换设置',
            name: 'hbSetting',
            path: 'hbSetting',
            keepAlive: true,
            component: () => import('@/view/mallSetting/hbSetting.vue')
          },
          // {
          //   title: '运费模版设置',
          //   name: 'transformFee',
          //   path: 'transformFee',
          //   keepAlive: true,
          //   component: () => import('@/view/autarky/transformFee.vue')
          // },
          {
            title: '运营广告设置',
            name: 'operateAd',
            path: 'operateAd',
            keepAlive: true,
            component: () => import('@/view/mallSetting/operateAd.vue')
          },
          {
            title: '搜索关键词',
            name: 'searchWord',
            path: 'searchWord',
            keepAlive: true,
            component: () => import('@/view/mallSetting/searchWord.vue')
          },
          {
            title: '进货活动商品配置',
            name: 'purchaseActivity',
            path: 'purchaseActivity',
            keepAlive: true,
            component: () => import('@/view/mallSetting/purchaseActivity.vue')
          }
        ]
      },
      {
        title: '订单管理',
        hasGroup: true,
        child: [
          {
            title: '兑换订单列表',
            name: 'privateorderlist',
            path: 'privateorderlist',
            keepAlive: true,
            component: () => import('@/view/autarky/privateorderlist.vue')
          },
          {
            title: '订单详情',
            hideInMenu: true,
            name: 'preorderdetail',
            path: 'preorderdetail',
            component: () => import('@/view/autarky/preorderdetail.vue')
          },
          {
            title: '会员兑换订单列表',
            name: 'memberorderlist',
            path: 'memberorderlist',
            keepAlive: true,
            component: () => import('@/view/autarky/memberorderlist.vue')
          },
          {
            title: '订单详情',
            hideInMenu: true,
            name: 'memberdetail',
            path: 'memberdetail',
            component: () => import('@/view/autarky/memberdetail.vue')
          },
          {
            title: 'BC商家自营订单',
            name: 'selfOrder',
            path: 'selfOrder',
            component: () => import('@/view/autarky/selfOrder.vue')
          },
          {
            title: '免费店订单',
            name: 'freeOrder',
            path: 'freeOrder',
            component: () => import('@/view/autarky/freeOrder.vue')
          },
          {
            title: '免费店订单详情',
            hideInMenu: true,
            name: 'freeOrderDetail',
            path: 'freeOrderDetail',
            component: () => import('@/view/autarky/freeOrderDetail.vue')
          },
          {
            title: '关闭订单申请',
            name: 'closeOrderApply',
            path: 'closeOrderApply',
            keepAlive: true,
            component: () => import('@/view/autarky/closeOrderApply.vue')
          },
        ]
      },
      {
        title: '用户管理',
        hasGroup: true,
        child: [
          {
            title: '商户列表',
            name: 'onlineBusiness',
            path: 'onlineBusiness',
            component: () => import('@/view/management/onlineBusiness.vue')
          },
          {
            title: '用户列表',
            name: 'normalUser',
            path: 'normalUser',
            component: () => import('@/view/management/normalUser.vue')
          },
          {
            title: '用户红包记录',
            name: 'userRedList',
            path: 'userRedList',
            hideInMenu: true,
            component: () => import('@/view/management/userRedList.vue')
          },
          {
            title: '不花钱店管理',
            name: 'freeGoodsManage',
            path: 'freeGoodsManage',
            component: () => import('@/view/management/freeGoodsManage.vue')
          },
          {
            title: '不花钱店红包商品管理',
            name: 'freeGoodsEdit',
            path: 'freeGoodsEdit',
            hideInMenu: true,
            component: () => import('@/view/management/freeGoodsEdit.vue')
          }
        ]
      },
      {
        title: '红包充值管理',
        hasGroup: true,
        child: [
          {
            title: '红包充值设置',
            name: 'redpacketPull',
            path: 'redpacketPull',
            keepAlive: true,
            component: () => import('@/view/others/redpacketPull.vue')
          },
          {
            title: '红包充值记录',
            name: 'redpacketRechargeList',
            path: 'redpacketRechargeList',
            keepAlive: true,
            component: () => import('@/view/others/redpacketRechargeList.vue')
          },
          {
            title: '红包获取每日排行',
            name: 'redpacketRank',
            path: 'redpacketRank',
            keepAlive: true,
            component: () => import('@/view/others/redpacketRank.vue')
          },
          {
            title: '红包统计',
            name: 'redpacketStatistics',
            path: 'redpacketStatistics',
            keepAlive: true,
            component: () => import('@/view/others/redpacketStatistics.vue')
          },
          {
            title: '红包发放统计',
            name: 'putOut',
            path: 'putOut',
            keepAlive: true,
            component: () => import('@/view/others/putOut.vue')
          }
        ]
      },
      {
        title: '红包卡管理',
        hasGroup: true,
        child: [
          {
            title: '红包卡管理',
            name: 'redpacketManage',
            path: 'redpacketManage',
            keepAlive: true,
            component: () =>
              import('@/view/redpacketManage/redpacketManage.vue')
          },
          {
            title: 'BC推广员',
            name: 'bcPromoter',
            path: 'bcPromoter',
            keepAlive: true,
            component: () => import('@/view/redpacketManage/bcPromoter.vue')
          },
          {
            title: '红包卡转移记录',
            name: 'moveRecord',
            path: 'moveRecord',
            keepAlive: true,
            component: () => import('@/view/redpacketManage/moveRecord.vue')
          },
          {
            title: '红包卡激活明细',
            name: 'activationRecord',
            path: 'activationRecord',
            keepAlive: true,
            component: () =>
              import('@/view/redpacketManage/activationRecord.vue')
          },
          {
            title: '查看bc卡',
            hideInMenu: true,
            name: 'lookBcCard',
            path: 'lookBcCard',
            component: () => import('@/view/redpacketManage/lookBcCard.vue')
          },
          {
            title: '查看红包卡',
            hideInMenu: true,
            name: 'lookRedCard',
            path: 'lookRedCard',
            component: () => import('@/view/redpacketManage/lookRedCard.vue')
          },
          {
            title: '查看红包卡激活详情',
            hideInMenu: true,
            name: 'activationDetails',
            path: 'activationDetails',
            component: () =>
              import('@/view/redpacketManage/activationDetails.vue')
          }
        ]
      },
      {
        title: 'BC销售系统',
        hasGroup: true,
        child: [
          {
            title: '附近爆品商品',
            name: 'nearbyHot',
            path: 'nearbyHot',
            component: () => import('@/view/bcSystem/nearbyHot.vue')
          },
          {
            title: '商品详情',
            name: 'nearbyHotDetail',
            path: 'nearbyHotDetail',
            hideInMenu: true,
            component: () => import('@/view/bcSystem/nearbyHotDetail.vue')
          },
        ]
      },
    ]
  },
  {
    title: '登录',
    name: 'login',
    path: '/login',
    component: () => import('@/view/login/index.vue'),
    redirect: '/login/signin',
    hideInMenu: true,
    child: [
      {
        title: '登录',
        name: 'signin',
        path: 'signin',
        component: () => import('@/view/login/signin.vue')
      },
      {
        title: '注册',
        name: 'signup',
        path: 'signup',
        component: () => import('@/view/login/signup.vue')
      }
    ]
  },
  {
    title: '小店管理',
    name: 'management',
    path: '/management',
    component: Main,
    secondMenuTitle: '小店管理',
    redirect: '/management/residenceaudit',
    child: [
      {
        title: '入驻管理',
        hasGroup: true,
        child: [
          // { title: "小店管理", name: 'index', hideInMenu: true, showName:"ruzhu",path: 'index', component: () => import('@/view/management/index.vue') },
          {
            title: '小店入驻审核',
            name: 'residenceaudit',
            path: 'residenceaudit',
            keepAlive: true,
            component: () => import('@/view/management/residenceaudit.vue')
          },
          //  {
          //    title: '小店入驻管理',
          //    name: 'residencemanagement',
          //    path: 'residencemanagement',
          //    keepAlive:true,
          //    component: () =>
          //      import('@/view/management/residencemanagement.vue')
          //  },

          {
            title: '小店加盟订单',
            name: 'shopJoinOrder',
            path: 'shopJoinOrder',
            component: () => import('@/view/management/shopJoinOrder.vue')
          },
          {
            title: '小店入驻详情',
            name: 'residenceInformation',
            path: 'residenceInformation',
            hideInMenu: true,
            component: () =>
              import('@/view/management/residenceInformation.vue')
          }
        ]
      },
      {
        title: '小店管理',
        hasGroup: true,
        child: [
          {
            title: '小店列表',
            name: 'shoplist',
            path: 'shoplist',
            keepAlive: true,
            component: () => import('@/view/management/shoplist.vue')
          },
          {
            title: '小店详情',
            name: 'shoplistDetail',
            path: 'shoplistDetail',
            hideInMenu: true,
            component: () =>
              import('@/view/management/shoplistDetail/index.vue')
          },
          {
            title: '小店分类管理',
            name: 'shopcategory',
            path: 'shopcategory',
            keepAlive: true,
            component: () => import('@/view/management/shopcategory.vue')
          },
          {
            title: '小店移除记录',
            name: 'shopRemoverec',
            path: 'shopRemoverec',
            // keepAlive:true,
            component: () => import('@/view/management/shopRemoverec.vue')
          },
          {
            title: '分类详情',
            name: 'shopcategorydetail',
            path: 'shopcategorydetail',
            hideInMenu: true,
            component: () =>
              import('@/view/management/shopcategorydetail/index.vue')
          },
          {
            title: '小店分组管理',
            name: 'shopgroup',
            path: 'shopgroup',
            keepAlive: true,
            hideInMenu: true,
            component: () => import('@/view/management/shopgroup.vue')
          },
          {
            title: '分组详情',
            name: 'shopgroupDetail',
            path: 'shopgroupDetail',
            hideInMenu: true,
            component: () =>
              import('@/view/management/shopgroupDetail/index.vue')
          },
          {
            title: '小店会员管理',
            name: 'shopMember',
            path: 'shopMember',
            keepAlive: true,
            component: () => import('@/view/management/shopMember.vue')
          },
          {
            title: '小店会员详情',
            name: 'shopMemberdetailRouter',
            path: 'shopMemberdetailRouter',
            hideInMenu: true,
            component: () =>
              import('@/view/management/shopMemberdetailRouter.vue')
          },

          {
            title: '小店操作日志',
            name: 'shopLog',
            path: 'shopLog',
            keepAlive: true,
            component: () => import('@/view/management/shopLog/index.vue')
          }
        ]
      },
      {
        title: '员工管理',
        hasGroup: true,
        child: [
          {
            title: '员工角色管理',
            name: 'staffrole',
            path: 'staffrole',
            component: () => import('@/view/management/staffrole.vue')
          },
          {
            title: '小店员工管理',
            name: 'shopstaff',
            path: 'shopstaff',
            component: () => import('@/view/management/shopstaff.vue')
          }
        ]
      }
    ]
  },
  {
    title: '小店运营',
    name: 'operate',
    path: '/operate',
    component: Main,
    secondMenuTitle: '小店运营',
    redirect: '/operate/shopadministration', //title: "小店管理", name: 'index', hideInMenu: true, showName:"ruzhu",path: 'index', component: () => import('@/view/management/index.vue')

    child: [
      //{ title: "小店运营", hideInMenu: true, showName:"shopexamine", name: 'index', path: 'index', component: () => import('@/view/operate/index.vue') },

      {
        title: '商品管理',
        hasGroup: true,
        child: [
          //  {
          //    title: '小店商品审核',
          //    name: 'shopexamine',
          //    path: 'shopexamine',
          //    component: () => import('@/view/operate/shopexamine.vue')
          //  },
          {
            title: '小店商品管理',
            name: 'shopadministration',
            path: 'shopadministration',
            keepAlive: true,
            component: () => import('@/view/operate/shopadministration.vue')
          },
          {
            title: '',
            name: 'shopadministrationdetail',
            path: 'shopadministrationdetail',
            hideInMenu: true,
            component: () =>
              import('@/view/operate/shopadministrationdetail.vue')
          }
        ]
      },
      {
        title: '小店活动管理',
        hasGroup: true,
        child: [
          {
            title: '小店活动列表',
            name: 'activelist',
            path: 'activelist',
            keepAlive: true,
            component: () => import('@/view/operate/activelist.vue')
          },
          {
            title: '营销插件管理',
            name: 'marketingplugin',
            path: 'marketingplugin',
            keepAlive: true,
            component: () => import('@/view/operate/marketingplugin.vue')
          }
        ]
      },
      {
        title: '优惠券管理',
        hasGroup: true,
        child: [
          {
            title: '满减券列表',
            name: 'avoucherslist',
            path: 'voucherslist',
            keepAlive: true,
            component: () => import('@/view/operate/voucherslist.vue')
          },
          {
            title: '领取记录',
            name: 'vouchersgetterlist',
            path: 'vouchersgetterlist',
            hideInMenu: true,
            keepAlive: true,
            component: () => import('@/view/operate/vouchersgetterlist.vue')
          },
          {
            title: '现金券列表',
            name: 'cashlist',
            path: 'cashlist',
            keepAlive: true,
            component: () => import('@/view/operate/cashlist.vue')
          },
          {
            title: '购买记录',
            name: 'cashbuylist',
            path: 'cashbuylist',
            hideInMenu: true,
            component: () => import('@/view/operate/cashbuylist.vue')
          }
        ]
      },
      {
        title: '小店商城管理',
        hasGroup: true,
        child: [
          {
            title: '小店爆品管理',
            name: 'explosiveproducts',
            path: 'explosiveproducts',
            keepAlive: true,
            component: () => import('@/view/operate/explosiveproducts.vue')
          },
          {
            title: '会员专享管理',
            name: 'specialoffer',
            path: 'specialoffer',
            component: () => import('@/view/operate/specialoffer.vue')
          }
        ]
      },
      {
        title: '小店订单管理',
        hasGroup: true,
        child: [
          {
            title: '商城订单管理',
            name: 'shoporder',
            path: 'shoporder',
            keepAlive: true,
            component: () => import('@/view/operate/shoporder.vue')
          },

          {
            title: '订单详情',
            name: 'shoporderdetail',
            path: 'shoporderdetail',
            hideInMenu: true,
            component: () => import('@/view/operate/shoporderdetail.vue')
          },
          {
            title: '现金券订单管理',
            name: 'cashcouponorder',
            path: 'cashcouponorder',
            keepAlive: true,
            component: () => import('@/view/operate/cashcouponorder.vue')
          },
          {
            title: '会员订单管理',
            name: 'vipOrder',
            path: 'vipOrder',
            keepAlive: true,
            component: () => import('@/view/operate/orders/vipOrder.vue')
          },
          {
            title: '优惠买单记录',
            name: 'saleOrder',
            path: 'saleOrder',
            keepAlive: true,
            component: () => import('@/view/operate/orders/saleOrder.vue')
          }
          //  {
          //    title: '会员卡充值订单管理',
          //    name: 'membercardOrderlist',
          //    path: 'membercardOrderlist',
          //    component: () =>
          //      import('@/view/operate/membercardOrderlist.vue')
          //  }
        ]
      }
    ]
  },
  {
    title: '自营管理',
    name: 'autarky',
    path: '/autarky',
    component: Main,
    secondMenuTitle: '自营管理',
    redirect: '/autarky/supplyChainStore',

    child: [
      {
        title: '选品管理',
        hasGroup: true,
        child: [
          {
            title: '供应链商品库',
            name: 'supplyChainStore',
            path: 'supplyChainStore',
            keepAlive: true,
            component: () => import('@/view/autarky/supplyChainStore.vue')
          },
          {
            title: '选品设置',
            name: 'addshopTostore',
            path: 'addshopTostore',
            hideInMenu: true,
            component: () => import('@/view/autarky/addshopTostore.vue')
          },
          {
            title: '本地商品库',
            name: 'localstore',
            path: 'localstore',
            keepAlive: true,
            component: () => import('@/view/autarky/localstore.vue')
          },
          {
            title: '销售日志',
            name: 'saledaily',
            path: 'saledaily',
            hideInMenu: true,
            component: () => import('@/view/autarky/saledaily.vue')
          }
        ]
      },
      {
        title: '订单管理',
        hasGroup: true,
        child: [
          {
            title: '自营订单列表',
            name: 'privateorderlist',
            path: 'privateorderlist',
            keepAlive: true,
            component: () => import('@/view/autarky/privateorderlist.vue')
          },
          {
            title: '订单详情',
            name: 'serviceDetailInfo',
            hideInMenu: true,
            path: 'serviceDetailInfo',
            component: () => import('@/view/autarky/serviceDetailInfo.vue')
          },

          {
            title: '订单详情',
            hideInMenu: true,
            name: 'preorderdetail',
            path: 'preorderdetail',
            component: () => import('@/view/autarky/preorderdetail.vue')
          }
        ]
      },
      {
        title: '商品分类管理',
        hasGroup: true,
        child: [
          {
            title: '红包兑换专区',
            name: 'shopcategorylist',
            path: 'shopcategorylist',
            keepAlive: true,
            component: () => import('@/view/autarky/shopcategorylist.vue')
          },

          {
            title: '京东CPS分类',
            name: 'jdcpscatemanagent',
            path: 'jdcpscatemanagent',
            component: () => import('@/view/autarky/jdcpscatemanagent.vue')
          }
          //  {
          //    title: '服务商专区套餐',
          //    name: 'servicepackagelist',
          //    path: 'servicepackagelist',
          //    component: () =>
          //      import('@/view/autarky/servicepackagelist.vue')
          //  }
        ]
      },
      {
        // transformFee
        title: '商品上架设置',
        hasGroup: true,
        child: [
          {
            title: '运费模版设置',
            name: 'transformFee',
            path: 'transformFee',
            keepAlive: true,
            component: () => import('@/view/autarky/transformFee.vue')
          }
        ]
      }
    ]
  },
  {
    title: '服务商管理',
    name: 'ISP',
    path: '/ISP',
    component: Main,
    secondMenuTitle: '服务商管理',
    redirect: '/ISP/ispServicelist',

    child: [
      //{title: "其他设置", hideInMenu: true, showName:"templatemessage", name: 'index', path: 'index', component: () => import('@/view/others/index.vue')},
      //  {
      //    title: '区域管理',
      //    hasGroup: true,
      //    child: [
      //      {
      //        title: '招商区域管理',
      //        name: 'ispAreamanagent',
      //        path: 'ispAreamanagent',
      //        component: () => import('@/view/ISP/ispAreamanagent.vue')
      //      },

      //      {
      //        title: '省级区域详情',
      //        name: 'ispProvinceDetail',
      //        path: 'ispProvinceDetail',
      //        hideInMenu: true,
      //        component: () => import('@/view/ISP/ispProvinceDetail.vue')
      //      },
      //      {
      //        title: '区域详情',
      //        name: 'ispAreaDetail',
      //        path: 'ispAreaDetail',
      //        hideInMenu: true,
      //        component: () => import('@/view/ISP/ispAreaDetail.vue')
      //      },

      //    ]
      //  },

      {
        title: '服务商管理',
        hasGroup: true,
        child: [
          {
            title: '服务商列表',
            name: 'ispServicelist',
            path: 'ispServicelist',
            keepAlive: true,
            component: () => import('@/view/ISP/ispServicelist.vue')
          },
          {
            title: '服务商订单列表',
            name: 'serviceArea',
            path: 'serviceArea',
            keepAlive: true,
            component: () => import('@/view/autarky/serviceArea.vue')
          },
          {
            title: '被移除服务商',
            name: 'ispDeleteService',
            path: 'ispDeleteService',
            component: () => import('@/view/ISP/ispDeleteService.vue')
          },
          {
            title: '服务商资质审核',
            name: 'ispServiceCerAudit',
            path: 'ispServiceCerAudit',
            component: () => import('@/view/ISP/ispServiceCerAudit.vue')
          },
          {
            title: '编辑服务商',
            name: 'ispEditService',
            path: 'ispEditService',
            hideInMenu: true,
            component: () => import('@/view/ISP/ispEditService.vue')
          },
          {
            title: '服务商收益明细',
            name: 'ispIncomeDetail',
            path: 'ispIncomeDetail',
            hideInMenu: true,
            component: () => import('@/view/ISP/ispIncomeDetail.vue')
          },
          {
            title: '红包记录',
            name: 'ispRedPacket',
            path: 'ispRedPacket',
            hideInMenu: true,
            component: () => import('@/view/ISP/ispRedPacket.vue')
          },
          {
            title: '服务商详情',
            name: 'ispServiceDetail',
            path: 'ispServiceDetail',
            hideInMenu: true,
            component: () => import('@/view/ISP/ispServiceDetail.vue')
          }
        ]
      }
    ]
  },
  {
    title: '财务管理',
    name: 'finance',
    path: '/finance',
    component: Main,
    secondMenuTitle: '财务管理',
    redirect: '/finance/incomedetail',

    child: [
      //{title: "财务管理", hideInMenu: true, showName:"incomedetail", name: 'index', path: 'index', component: () => import('@/view/finance/index.vue')},

      {
        title: '门店交易数据',
        hasGroup: true,
        child: [
          {
            title: '小店收入明细',
            name: 'incomedetail',
            path: 'incomedetail',
            component: () => import('@/view/finance/incomedetail.vue')
          },
          {
            title: '小店交易记录',
            name: 'transactionrecord',
            path: 'transactionrecord',
            component: () => import('@/view/finance/transactionrecord.vue')
          }
        ]
      },
      {
        title: '佣金订单数据',
        hasGroup: true,
        child: [
          {
            title: '淘客佣金记录',
            name: 'onlineIncomes',
            path: 'onlineIncomes',
            component: () => import('@/view/finance/onlineIncomes.vue')
          },
          {
            title: '自营订单结算',
            name: 'settleorderlist',
            path: 'settleorderlist',
            component: () => import('@/view/finance/settleorderlist.vue')
          },

          {
            title: '京东佣金记录',
            name: 'jdonlineIncome',
            path: 'jdonlineIncome',
            component: () => import('@/view/finance/jdonlineIncome.vue')
          }
        ]
      },

      {
        title: '对账管理',
        hasGroup: true,
        child: [
          {
            title: '提现申请管理',
            name: 'discountrecord',
            path: 'discountrecord',
            keepAlive: true,
            component: () => import('@/view/finance/discountrecord.vue')
          },
          {
            title: '代扣税明细',
            name: 'withholdTax',
            path: 'withholdTax',
            component: () => import('@/view/finance/withholdTax.vue')
          },
          {
            title: '扣税申请管理',
            name: 'refundTax',
            path: 'refundTax',
            keepAlive: true,
            component: () => import('@/view/finance/refundTax.vue')
          }
          //  {
          //    title: '平台对账管理',
          //    name: 'platformreconciliation',
          //    path: 'platformreconciliation',
          //    component: () =>
          //      import('@/view/finance/platformreconciliation.vue')
          //  }
        ]
      }
    ]
  },
  {
    title: '其他设置',
    name: 'others',
    path: '/others',
    component: Main,
    secondMenuTitle: '其他设置',
    redirect: '/others/templatemessage',

    child: [
      //{title: "其他设置", hideInMenu: true, showName:"templatemessage", name: 'index', path: 'index', component: () => import('@/view/others/index.vue')},
      {
        title: '系统设置',
        hasGroup: true,
        child: [
          {
            title: '模版消息设置',
            name: 'templatemessage',
            path: 'templatemessage',
            component: () => import('@/view/others/templatemessage.vue')
          },
          {
            title: '小店权限设置',
            name: 'shopauthority',
            path: 'shopauthority',
            component: () => import('@/view/others/shopauthority.vue')
          }
          // {title:'小程序展示设置',name:'shopdisplay',path:'shopdisplay',component:() => import('@/view/others/shopdisplay.vue')},
        ]
      },
      {
        title: '喜卡管理',
        hasGroup: true,
        child: [
          {
            title: '会员卡管理',
            name: 'membercard',
            path: 'membercard',
            keepAlive: true,
            component: () => import('@/view/others/membercard.vue')
          }
        ]
      },
      {
        title: '充值设置',
        hasGroup: true,
        child: [
          {
            title: '红包充值设置',
            name: 'redpacketPull',
            path: 'redpacketPull',
            keepAlive: true,
            component: () => import('@/view/others/redpacketPull.vue')
          },
          {
            title: '红包充值记录',
            name: 'redpacketRechargeList',
            path: 'redpacketRechargeList',
            keepAlive: true,
            component: () => import('@/view/others/redpacketRechargeList.vue')
          }
        ]
      }
    ]
  }
]
